module.exports = __webpack_public_path__ + "083160ecacd114bd0a3bd3cbab785c7a.svg";